import { useCallback } from "react";
import { useJobSearch } from "../../reducers/jobSlice";
import { useStatsContext } from "./JobStatsContext";
import { CrewLayer, JobLayer, LocationLayer } from "../map/Marker";
import { Suspense } from "react";
import { BaseMap, DefaultView } from "../GeoMap";
import { Spinner } from "react-bootstrap";
import { cdate } from "../../common/utils/CDate";
import useClientConfig from "../../common/hooks/clientConfigHook";
import { now } from "moment";

const JobStatsMap = () => {
    const { search } = useStatsContext();
    const clientConfig = useClientConfig();
    const jobs = useJobSearch(search);
    const showCrew = cdate(search.end, clientConfig.tz).isAfter(now(clientConfig.tz));

    const layers = useCallback((showLabel) => <>
        <JobLayer mode="ol" showLabel={showLabel} jobs={jobs}></JobLayer>
        { showCrew ? <CrewLayer mode='ol' showLabel={showLabel}></CrewLayer> : null }
        <LocationLayer mode='ol' showLabel={showLabel} ></LocationLayer>
    </>, [showCrew, jobs])
    return <Suspense fallback={<Spinner animation="border" variant="primary"></Spinner>}>
        <BaseMap controls={<DefaultView></DefaultView>} layers={layers} allowEdit={false} defaultFocus={false}>
        </BaseMap>
    </Suspense>
}

export default JobStatsMap;